<template>
  <section>
    <b-modal :active.sync="isComponentPassActive" has-modal-card :can-cancel="false">
      <div class="modal-card">
          <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
        <header class="modal-card-head">
          <p class="modal-card-title">Cambiar Contraseña</p>
        </header>
        <section class="modal-card-body">
          <b-field label="Contraseña Actual">
            <b-input
              type="password"
              v-model="user.current_password"
              placeholder="Contraseña Actual"
              required
            ></b-input>
          </b-field>
       
            <b-field label="Contraseña Nueva">
            <b-input
              type="password"
              v-model="user.password"
              placeholder="Nueva Contraseña"
              required
            ></b-input>
          </b-field>
          <b-field label="Repita su nueva contraseña">
            <b-input
              type="password"
              
              v-model="user.password_confirmation"
              placeholder="Repite Contraseña"
              required
            ></b-input>
          </b-field>
         
         
       
        
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="closeEditPassword()">Cerrar</button>
          <button class="button is-primary" @click="editPassword()">Editar</button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>
<script>
export default {
  props: ["isComponentPassActive", "closeEditPassword", "user_id"],
  data() {
    return {
      user: {
        current_password:"",
        password:"",
        password_confirmation: ""
      },
      
      isLoading:true,
      
    };
  },
  created: function() {
    this.isLoading=false
  },
  methods: {
    
    editUser: function() {
      this.isLoading=true;
      let data = {
        ...this.user
      };
      this.$http.put(`api/${localStorage.getItem('perfil')}/user/` + this.user_id, data).then(
        response => {
          //Limpia el objeto User
          for (const i in this.user) {
            this.user[i] = "";
          }
          console.log(response);
          this.closeBasic();
          this.toast("Editado el Usuario", "is-success");
          this.isLoading=false;
        },
        response => {
          console.log(response);
          this.toast("error al editar", "is-danger");
          this.isLoading=false;
        }
      );
    },
    editPassword:function(){
          this.$buefy.dialog.confirm({
                    
                    message: '¿Desea Continuar?',
                    confirmText: 'Si',
                    type: 'is-primary',
                    hasIcon: true,
                    onConfirm:()=>{
                       this.isLoading=true;
                        let data = {
                          current_password:this.user.current_password,
                          password:this.user.password,
                          password_confirmation:this.user.password_confirmation
                        };
                        
                        
                        this.$http.put(`api/${localStorage.getItem('perfil')}/user/change_passwd/` + this.user_id, data).then(
                          response => {
                            //Limpia el objeto User
                            for (const i in this.user) {
                              this.user[i] = "";
                            }
                            console.log(response);
                            this.closeEditPassword();
                            this.toast("Editada la contraseña", "is-success");
                            this.isLoading=false;
                          },
                          response => {
                            console.log(response);
                            this.toast("error al editar", "is-danger");
                            this.isLoading=false;
                          }
                        );
                                    
                    } 
                })

    }
    
 
    
  
  }
};
</script>